<template>
  <section class="content checkout-content wp_AllPageMarginTop">
    <!-- <h5 id="view-cart-heading">My Cart</h5>
    <div class="row">
      <cart-list :cartProducts="getCartProducts">
      </cart-list>
      <cart-summary-container
        :proceedButton="true"
        v-if="(getCartProducts && getCartProducts.length > 0)"
      >
      </cart-summary-container>
    </div> -->
    <pincode-modal>
    </pincode-modal>
    <cart-container :productsData="getCartProducts.slice().reverse()"
                    :productCount="getCartCount"
                    :totalPrice="getcartTotal"
                    :totalCartPrice="getcartItemTotal"
                    :totalOffer="getcartTotalOffer"
    >
     </cart-container>
    <!--<article class="savelater-w">-->
    <!--<div class="left">-->
    <!--<p class="h6">
    <i class="fas fa-cart-arrow-down"></i>
    <span class="ml-2">Save later</span></p>-->
    <!--<div class="savelater-wrapper">-->
    <!--<div class="cart-items-wrapper">-->
    <!--<div class="cart-item" v-for="(product, index) in getCartProducts"-->
    <!--:key="index">-->
    <!--<div class="cart-grid">-->
    <!--<div class="cart-contents-wrapper">-->
    <!--<div class="description">-->
    <!--<p class="cart-product-title">{{product.product_name}}</p>-->
    <!--&lt;!&ndash;<small class="options">Size: <span>M</span></small>&ndash;&gt;-->
    <!--<small class="seller">Seller: <span>{{product.vendor_name}}</span></small>-->
    <!--</div>-->
    <!--<div class="pricy" v-if="product.promotion_id">-->
    <!--<span>{{product.promotion_applied_price | currencyConversion}}</span>-->
    <!--<span>{{product.price | currencyConversion}}</span>-->
    <!--<span>{{product.discount_percentage}}% off</span>-->
    <!--</div>-->

    <!--<div class="pricy" v-if="!product.promotion_id">-->
    <!--<span>{{product.price | currencyConversion}}</span>-->
    <!--&lt;!&ndash;<span>50% off</span>&ndash;&gt;-->
    <!--</div>-->
    <!--&lt;!&ndash;<p class="itemleft">Hurry, Only 5 left!</p>&ndash;&gt;-->
    <!--<div class="cart-button-block">-->
    <!--<a type="a" name="" id="" class="btn btn-primary btn-type-primary"-->
    <!--@click.prevent="cartAddToWishlist(product.product_id)">-->
    <!--<i class="fas fa-cart-plus"></i>-->
    <!--Move to Cart</a>-->
    <!--<a type="a" name="" id="" class="btn btn-primary btn-type-primary"-->
    <!--@click.prevent="deleteProduct(product.product_id)">-->
    <!--<i class="fas fa-trash"></i>-->
    <!--Remove</a>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="cart-image-warpper">-->
    <!--<img class="cart-product-image" :src=product.image_url alt="">-->
    <!--<div class="quantity-warpper">-->
    <!--&lt;!&ndash;<integer-plusminus :min="1"&ndash;&gt;-->
    <!--&lt;!&ndash;:max="quantity"&ndash;&gt;-->
    <!--&lt;!&ndash;v-model="product.quantity"&ndash;&gt;-->
    <!--&lt;!&ndash;v-if="!($route.path === '/order-success')"&ndash;&gt;-->
    <!--&lt;!&ndash;&gt;&ndash;&gt;-->
    <!--&lt;!&ndash;</integer-plusminus>&ndash;&gt;-->
    <!--&lt;!&ndash;<input type="number"&ndash;&gt;-->
    <!--&lt;!&ndash;:value=product.quantity&ndash;&gt;-->
    <!--&lt;!&ndash;v-else&ndash;&gt;-->
    <!--&lt;!&ndash;disabled&ndash;&gt;-->
    <!--&lt;!&ndash;&gt;&ndash;&gt;-->
    <!--<div class="select" name="" id="" @click.prevent="toggleQty">-->
    <!--<span class="">Qty: {{product.quantity}}</span>-->
    <!--<div class="options" id="qty00">-->
    <!--<div class="option" value="">1</div>-->
    <!--<div class="option" value="">2</div>-->
    <!--<div class="option" value="">3</div>-->
    <!--<div class="option" value="">4</div>-->
    <!--<div class="option" value="" data-toggle="modal" data-target="#priceModal">More</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</article>-->
    <no-cart-products-container>
    </no-cart-products-container>
  </section>
</template>

<script>
// import CartSummaryContainer from '@/components/widgets/CartSummaryContainer';
// import CartList from '@/components/widgets/CartList';
import NoCartProductsContainer from '@/components/pages/cart/widgets/NoCartProductsContainer'
import CartContainer from '@/components/pages/cart/cartContainer/CartContainer'
import PincodeModal from '@/components/pages/cart/modals/PincodeModal'
import { mapActions, mapGetters } from 'vuex'
import { store } from '@/store/store'
import { cartApis } from '@/services/ApiServices/cartApis'
// import { customerApi } from '@/services/ApiServices/customerApi'
// import PriceModal from './PriceModal'

export default {
	data () {
		return {
			qnty: 1,
			item: ''
		}
	},
	components: {
		// CartSummaryContainer,
		// CartList,
		PincodeModal,
		// PriceModal,
		NoCartProductsContainer,
		CartContainer
	},
	props: {
		buttonShow: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters('cart', ['getCartProducts', 'getCartCount', 'getcartTotal', 'getcartItemTotal', 'getcartTotalOffer'])

	},
	beforeCreate () {
		// if (this.isAuthenticated) {
		//   cartApis.insertCart().then(() => {
		//     cartApis.getCart();
		//   });
		//   store.dispatch('cart/emptyCart');
		// } else {
		store.dispatch('buynow/deleteFromBuyNow')
		store.dispatch('user/setPromoCodeData', '')
		cartApis.updateCart()
		// }
	},
	mounted () {
		this.bindFixedScrollFunction()
	},
	methods: {
		...mapActions('cart', ['deleteFromCart', 'updateCartQuantity']),
		...mapActions('wishlist', ['addToWishlist']),
		bindFixedScrollFunction () {
			$(window)
				.scroll(() => {
					const fixedCart = document.getElementsByClassName('fixed-cart-card')
					if ($(window)
						.scrollTop() >= 150) {
						// $('.fixed-cart-card').addClass('fixed');
						if (fixedCart && fixedCart[0]) {
							fixedCart[0].classList.remove('fixed')
						}
					} else if (fixedCart && fixedCart[0]) {
						// $('.fixed-cart-card').removeClass('fixed');
						fixedCart[0].classList.add('fixed')
					}
				})
		}
	}
}
</script>
